import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'

import CollapseIconButton from 'components/fulcrum/collapse/CollapseIconButton'
import { EditIconButton } from 'components/custom/EditIconButton/index'
import { IconButton } from 'react-toolbox/lib/button'
import Input from './Input'

const Actions = ({searchValue, onSearch, onEdit, onAdd, edit, toggleCollapse, collapse}) => {
  return (
    <Flex justify='flex-end'>
      <Input
        onChange={onSearch}
        value={searchValue}
      />
      <IconButton
        icon='add'
        onClick={onAdd}
      />
      <EditIconButton
        onClick={onEdit}
        edit={edit}
      />
      <CollapseIconButton
        toggleCollapse={toggleCollapse}
        collapse={collapse}
      />
    </Flex>
  )
}

export default Actions
